// extracted by mini-css-extract-plugin
module.exports = {"ScopesInspector":"ScopesInspector_ScopesInspector__0RYB_","Expandable":"ScopesInspector_Expandable__PaHrE"};